(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-bf-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-bf-slides')) {
    customElements.define(
      'mh-bf-slides',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.mh-bf-hero__slide')];
          this.index = 0;
          const interval = Number(this.dataset.interval) || 5000;
          if (this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => {
            if (!document.hidden) this.show(this.index + 1);
          }, interval);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        show(next) {
          this.slides[this.index].classList.remove('is-active');
          this.index = next % this.slides.length;
          const slide = this.slides[this.index];
          slide.querySelector('img[loading="lazy"]')?.setAttribute('loading', 'eager');
          slide.classList.add('is-active');
        }
      }
    );
  }

  if (!customElements.get('mh-bf-countdown')) {
    customElements.define(
      'mh-bf-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          if (Number.isNaN(this.end)) return;
          this.digits = {};
          this.querySelectorAll('[data-unit]').forEach((el) => (this.digits[el.dataset.unit] = el));
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const values = {
            days: Math.floor(remaining / 86400),
            hours: Math.floor((remaining % 86400) / 3600),
            minutes: Math.floor((remaining % 3600) / 60),
            seconds: remaining % 60,
          };
          for (const [unit, value] of Object.entries(values)) {
            if (this.digits[unit]) this.digits[unit].textContent = String(value).padStart(2, '0');
          }
          if (remaining === 0) clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-bf-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('mh-bf-signup__form')) return;

    const tagInput = form.querySelector('[data-base-tag]');
    if (!tagInput) return;

    const tags = [tagInput.dataset.baseTag];
    form.querySelectorAll('select[data-tag-prefix], input[data-tag-prefix]:checked').forEach((field) => {
      if (field.value) tags.push(field.dataset.tagPrefix + field.value);
    });
    tagInput.value = tags.filter(Boolean).join(', ');
  });

  } catch(e) { console.error(e); }
})();
})();
